import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
 
 
 
import {selectAuthLoading} from "../../../store/selectors/Auth";
import {useSelector} from "react-redux";
 
import TextBox from '../../Common/Textbox/large'
import Button from '../../Common/Buttons'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Email is required")
});

const ForgotPasswordForm = ({ handleSubmit, children, submitText }) => {
 
  const [showPassword, setShowPass] = useState(false);
  const loading = useSelector(selectAuthLoading);

  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={loginSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleChange }) => {
        return (
          <Form className={"form forget-form"}>
             <div className={"inputContainer"}>
          <TextBox type={"text"} handleChange={handleChange} tName={"email"} label={"Email"} additionClass={''} htmlFor="filled-adornment-email" />
          <ErrorMessage className="error" name="email" component="div" />
        </div>
        
          <Button loading={loading} additionClass={"EMPHASIS_EXTRA_DOUBLE_LARGE"} text={"Submit"} />
          </Form>
        );
      }}
    </Formik>
  );
}

export default ForgotPasswordForm;
